import React from 'react'
import { useContext } from 'react'
import { GeometryContext } from '../store/store'
import {RigidBody} from '@react-three/rapier'
import { useFrame } from '@react-three/fiber'
import { useState } from 'react'
import { useRef } from 'react'
import {useSelector} from 'react-redux'

const BlockAxe = ({position = [0,0,0]}) => {
    const geometryCtx = useContext(GeometryContext)
    // const geometryState = useSelector((state)=>state.geometry)
    const [timeOffset] = useState(()=> Math.random() * Math.PI * 0.2)
    const obstacle = useRef()

    useFrame((state)=>{
        const time = state.clock.getElapsedTime()
        const x = Math.sin(time * timeOffset) * 1.25
        obstacle.current.setNextKinematicTranslation({x: position[0]+ x, y: position[1] + 0.75, z: position[2]})
    })

    return (
        <group position={position}>
            <mesh
                geometry={geometryCtx.boxGeometry}
                material={geometryCtx.floor2Material}
                scale={[4,0.2,4]}
                position={[0,-0.1,0]}
                receiveShadow
            />
            <RigidBody ref={obstacle} type='kinematicPosition' restitution={2} friction={0} position={[0,0.2,0]}>
                <mesh
                    geometry={geometryCtx.boxGeometry}
                    material={geometryCtx.obstacleMaterial}
                    scale={[1.5,1.5,0.3]}
                    castShadow
                />
            </RigidBody>
        </group>
    )
}

export default BlockAxe